export default __webpack_public_path__ + "static/media/php.69379f56.png";